'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var CoderService = function CoderService($http, $q, $rootScope, $sanitize, $location) {

    var coderArray = [];

    /**
     * Get the list of coders
     */

    var data = function data() {
        var deferred = $q.defer();
        if (!coderArray.Promise) {
            $http.defaults.headers.common['Authorization'] = 'Bearer ' + $rootScope.globals.currentUser.token;
            coderArray = $http.get(WEBSERVICEURL + '/dataagility/api/service.person/allusers').then(function successCallback(response) {
                var names = [];
                angular.forEach(response.data, function (value, key) {
                    var sterilizedFn = $sanitize(value['firstname']);
                    var sterilizedLn = $sanitize(value['lastname']);
                    if (sterilizedFn && sterilizedLn) {
                        names.push({ id: value['id'], name: sterilizedFn + ' ' + sterilizedLn });
                    }
                });
                coderArray = names;
                deferred.resolve(names);
            }, function errorCallback(response) {
                if (response.status === 401) {
                    window.location.replace(window.location.origin + '/login?logout=true');
                }
            });
        } else {
            deferred.resolve(coderArray);
        }
        return deferred.promise;
    };

    return { data: data };
};

exports.default = CoderService;


// WEBPACK FOOTER //
// ./client/app/common/services/coder.service.js